























import Vue from 'vue';
import { mapState } from 'vuex';

import Section from '@/components/Bulma/Section.vue';
import Columns from '@/components/Bulma/Columns.vue';
import Column from '@/components/Bulma/Column.vue';

import CharacterCard from '@/components/CharacterCard.vue';

import CharacterType from '@/types/Character';

import Util from '@/util/Util';

export default Vue.extend({
	name: 'Characters',

	components: {
		Section,
		Columns,
		Column,
        CharacterCard
    },

	created() {
		Util.updateHeaders(this.$text('characters'), this.$text('readFavoriteCharacter'), process.env.VUE_APP_DEFAULT_IMAGE);
	},

	computed: {
		...mapState(['characters'])
	},

	methods: {
		selectCharacter(character: CharacterType): void {
			this.$router.push({ name: 'character', params: { characterId: character.characterId } });
			setTimeout(() => { Util.scrollToElementWithId('character'); }, 250);
		}
	}
});
